/**
 * 全站页脚
 * ============================================================
 * 只放两样东西：站点名、ICP 备案号。
 *
 * ── 为什么备案号必须出现在页面上 ──────────────────────────────
 * 这不是"好看不好看"的选择题。工信部《ICP 备案管理办法》要求
 * 备案号在网站首页底部展示，**并链接到 beian.miit.gov.cn**。
 * 备案下来后如果抽查到没展示，会被要求整改，严重的会注销备案。
 *
 * 所以：
 *   · 文字必须与备案证书**逐字一致**（粤ICP备2026160921号-1）
 *   · 必须是可点击的链接，跳 https://beian.miit.gov.cn/
 *   · 挂在与备案域名同一个站点的页面上（qdbot.wiki 及其子路径）
 *
 * ⚠️ 换域名/新增域名后：新域名也要有备案（或同一备案主体下的子备案），
 *    这个页脚跟着域名走，别只改代码不改备案。
 */

const BEIAN_NO = '粤ICP备2026160921号-1';
const BEIAN_URL = 'https://beian.miit.gov.cn/';

export default function SiteFooter() {
  return (
    <div className="pt-4 text-center leading-relaxed">
      <p className="text-[10px] text-zinc-300 dark:text-zinc-600">方言通 · DialectGo</p>
      <a
        href={BEIAN_URL}
        target="_blank"
        rel="noreferrer noopener"
        className="mt-0.5 inline-block text-[10px] text-zinc-400 underline-offset-2 active:opacity-60 hover:underline dark:text-zinc-500"
      >
        {BEIAN_NO}
      </a>
    </div>
  );
}
